import { apiClient } from '@/services';

const BASE = '/v1/pnr';

export const pnrApi = {
  generatePnr: (data) => apiClient.post(`${BASE}/generate`, data),
  retrievePnr: (data) => apiClient.post(`${BASE}/retrieve`, data),
  getBagStatus: (data) => apiClient.post(`${BASE}/bag-status`, data),
  upgradeBooking: (data) => apiClient.post(`${BASE}/upgrade-booking`, data),
  findFlights: (data) => apiClient.post(`${BASE}/find-flights`, data),
  parseNaturalLanguage: (data) => apiClient.post(`${BASE}/parse-nl`, data),
  // Deadhead (DHD) endpoints
  sendDhdMessage: (data) => apiClient.post(`${BASE}/dhd/send`, data),
  checkDhdResult: (data) => apiClient.post(`${BASE}/dhd/check`, data),
  generateDhdReference: () => apiClient.get(`${BASE}/dhd/generate-reference`),
  // DHD Bookings (My PNRs)
  listDhdBookings: () => apiClient.get(`${BASE}/dhd/bookings`),
  refreshDhdBooking: (id) => apiClient.post(`${BASE}/dhd/bookings/${id}/refresh`),
};
